var map = {
	"./aufdemhügelgolgatha.mp3": 358,
	"./meinezeitstehtindeinenhaenden.mp3": 332,
	"./stilldasmorgenrotglüht.mp3": 605,
	"./welcheinfreundistunserjesus.mp3": 859,
	"./werträgtmichdurch.mp3": 577,
	"./wonehmeichkrafther.mp3": 665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;